import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';

export default [
  {
    key: StatusEnum.Deleted,
    value: StatusEnum.Deleted,
    text: `Deleted (${StatusEnum.Deleted})`,
  },
  {
    key: StatusEnum.Free,
    value: StatusEnum.Free,
    text: `Free (${StatusEnum.Free})`,
  },
  {
    key: StatusEnum.Reduced,
    value: StatusEnum.Reduced,
    text: `Reduced (${StatusEnum.Reduced})`,
  },
  {
    key: StatusEnum.Paid,
    value: StatusEnum.Paid,
    text: `Paid (${StatusEnum.Paid})`,
  },
  {
    key: StatusEnum.Withdrawn,
    value: StatusEnum.Withdrawn,
    text: `Withdrawn (${StatusEnum.Withdrawn})`,
  },
  {
    key: StatusEnum.Teacher,
    value: StatusEnum.Teacher,
    text: `Teacher (${StatusEnum.Teacher})`,
  },
  {
    key: StatusEnum.Adult,
    value: StatusEnum.Adult,
    text: `Adult (${StatusEnum.Adult})`,
  },
  {
    key: StatusEnum.SchoolFoodService,
    value: StatusEnum.SchoolFoodService,
    text: `School Food Service (${StatusEnum.SchoolFoodService})`,
  },
  {
    key: StatusEnum.Catering,
    value: StatusEnum.Catering,
    text: `Catering (${StatusEnum.Catering})`,
  },
];



// WEBPACK FOOTER //
// ./src/common/Constants/Statuses.js